import NotificationPopup from './NotificationsPopup.component';

export default NotificationPopup;
